import React, {useContext} from 'react';
import {observer} from "mobx-react";
import * as Builder from "../../../builder";
import {TranslationDomainEnum} from "../../../types/enums";
import {TextType} from "../../../builder/form/type/TextType";
import {SubmitType} from "../../../builder/form/type/SubmitType";
import {ResetType} from "../../../builder/form/type/ResetType";
import {Translate} from "../../../components/util/translation.util";
import {StoreContext} from "../../../store.context";

export const FilterForm: React.FC<{
    onSubmit?: (values: any) => void,
    onReset?: () => void,
}> = observer(({ onSubmit, onReset}) => {
    const formReference = React.createRef() as any;

    const {
        appStore: {
            moduleStore: {
                agencyStore,
            },
        },
    } = useContext(StoreContext);

    return (
        <Builder.FilterForm
            ref={formReference}
            translationDomain={TranslationDomainEnum.COMPANY_ADMINISTRATION}
            collapsible={ true }
            title={<Translate message={`global.title.filter`} />}
            store={agencyStore}
            items={[
                {
                    position: 'left',
                    inputs: [
                        {
                            name: 'name',
                            label: 'agency.fields.name',
                            type: TextType,
                        },
                        {
                            name: 'externalId',
                            label: 'agency.fields.externalId',
                            type: TextType,
                        },
                        {
                            name: 'tpNumber',
                            label: 'agency.fields.tpNumber',
                            type: TextType,
                        },
                        {
                            name: 'chamberOfCommerceNumber',
                            label: 'agency.fields.chamberOfCommerceNumber',
                            type: TextType,
                        },
                        {
                            label: 'global.button.filter',
                            type: SubmitType,
                            translationDomain: TranslationDomainEnum.MESSAGES
                        },
                        {
                            type: ResetType,
                            translationDomain: TranslationDomainEnum.MESSAGES,
                            onClick: () => {
                                formReference.current?.resetForm();
                                onReset && onReset()
                            }
                        },
                    ]
                },
                {
                    position: 'right',
                    inputs: [
                        {
                            name: 'relationalId',
                            label: 'agency.fields.relationalId',
                            type: TextType,
                        },
                        {
                            name: 'wft',
                            label: 'agency.fields.wft',
                            type: TextType,
                        }
                    ]
                }
            ]}
            onFinish={(values: any) => { onSubmit && onSubmit(values) }}
            initialValues={[]}
        />
    )
})